import { gtmEventPush } from '../../modules/ga/GTMdatalayer';

export function showError(name, errorCode, config = {}, id='') {
  return {
    type: 'SHOW_HTTP_ERROR',
    name,
    errorCode,
    config,
    id
  };
}

export function hideError(name) {
  return {
    type: 'HIDE_HTTP_ERROR',
    name
  };
}

export function setErrorObject(errorObj = {}) {
  return {
    type: 'FLAT_ERROR_OBJECT',
    error: errorObj
  };
}

export function setGSTToast(errorObj = {}) {
  return dispatch => dispatch(setErrorObject(errorObj));
}

export function showErrorMessageInfo(errorObj = {}) {
  gtmEventPush({ event: 'page_error', error_message: errorObj.message });
  return dispatch => {
    dispatch(setErrorObject(errorObj));
    const timeOut = setTimeout(() => {
      dispatch(setErrorObject({}));
      clearTimeout(timeOut);
    }, 5000);
  }
}

export function setApiErrorList(error) {
  return {
    type: "SET_API_ERROR_LIST",
    error 
  }
};
